import React, { useEffect, useState, FC } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
//import { FormItem } from './useInterfaces/FormInterfeses';
import * as types from "../gql/graphql";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Paper, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AddIcon from '@mui/icons-material/Add';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Card from "@mui/material/Card";

import { styled, lighten, darken } from '@mui/system';

import { SubmitErrorHandler, SubmitHandler, useForm, Controller } from 'react-hook-form';

//import "primereact/resources/themes/md-light-indigo/theme.css";

import MDBoxRoot from './MDBox/MDBoxRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import { SchoolTime } from '../utils/SchoolTime';
import { useQueryAll } from '../apolloClient';

const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    textTransform: "capitalize",
    backgroundColor:
        theme.palette.mode === 'light'
            ? lighten(theme.palette.primary.light, 0.85)
            : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled('ul')(({ theme }) => ({
    padding: 0,
    color: theme.palette.primary.main,
    //color:"black"
}));


interface EditStudentDialogProps {
    StudentID: number;
}

const getPurchasesQuery = gql(`query GetPurchases($id:BigInt) {
      fs_purchasesCollection(filter: {Student: {eq: $id}}) {
          edges {
            node {
              nodeId
              id
              Date
              fs_students { id }
              fs_classes { name }
              fs_packages { name }
              fs_registrationsCollection { 
                edges {  node {
                  id 
                  fs_classes {  name id }
                  AvailableNum
                  fs_signupCollection {
                    edges {
                      node {
                        status
                        id
                        fs_events {
                          date
                        }
                      }
                    }
                  }
              }}
              }
            }
          }
        }
    }`);

const getClassesForPurchase = gql(`
    query GetClassesForPurchase($after: Cursor) {
      fs_classesCollection(
        filter: {active:{eq: true}}, 
        orderBy: [{category: AscNullsLast}, {listorder:AscNullsLast}],
        after: $after) {
          pageInfo { endCursor startCursor hasNextPage }
          edges {
            node {
              nodeId
              id
              name
            }
          }
        }
    }
   `);

const getPackagesForPurchase = gql(`
    query GetPackagesForPurchase($after: Cursor) {
      fs_packagesCollection(
        filter: {active:{eq: true}}, 
        orderBy: [{category: AscNullsLast}, {listorder:AscNullsLast}],
        after: $after ) {
          pageInfo { endCursor startCursor hasNextPage }
          edges {
            node {
              nodeId
              id
              name
            }
          }
        }
    }
   `);

const addPurchaseQuery = gql(`
   mutation AddPurchase($st:BigInt!, $so:Int!, $pa: BigInt!, $cl:BigInt!, $ad: Int, $nm: Int) {
       add_purchase(p_student: $st, p_source: $so, p_package:$pa, p_class:$cl, p_additional:$ad, p_number:$nm)
   }
  `);

const deleteSignUpQuery = gql(`
  mutation DeleteSignup($id:BigInt!) {
      delete_signup(p_id: $id)
  }
  `);

const deleteRegistrationQuery = gql(`
  mutation DeleteRegistration($id:BigInt!) {
      delete_registration(p_id: $id)
  }
  `);


// Build clean three level tree of purchase->registration->signup
interface Signup {
    id: number;
    class: string;
    status: string;
    eventDate: string;
}

interface Registration {
    id: number;
    class: string;
    classId: number;
    availableNum: number;
    signups: Signup[];
    signedNum: number;
    purchase: Purchase;
    date: string;
    prodName: string;
}

interface Purchase {
    id: number;
    date: string;
    studentId: number;
    class?: string;
    package?: string;
    name: string;
    registrations: Registration[];
}

interface RegistrationsListType {
    allSignups: Signup[];
    regs: Registration[];
}

const getStatus = (s) => { // scheduled - 0, attended - 1, waitlist - 2
    return (s == 0) && "Scheduled"
        || (s == 1) && "Attended"
        || (s == 2) && "Wait List";
};

interface PurchasesProps {
    StudentID: number; // Define the prop "number" as a number type
}

const StudentComplete: FC<PurchasesProps> = (props) => {

    const { data, error, loading, refetch } = useQuery(getPurchasesQuery, { variables: { id: props.StudentID }, fetchPolicy: 'network-only' });

    const { data: Cdata } = useQueryAll<types.Fs_ClassesEdge>({query: getClassesForPurchase});
    const { data: Pdata } = useQueryAll<types.Fs_PackagesEdge>({query:getPackagesForPurchase});

    const [purchasesList, setPurchasesList] = useState<RegistrationsListType>(null);
    const [signupList, setSignupList] = useState(null);
    const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
    const [isSignUpOpen, setIsSignUpOpen] = useState(false);

    const [registrationRow, setRegistrationRow] = useState(null);
    const [isAddSignUpModalOpen, setIsAddSignUpModalOpen] = useState(false);

    const { register: purchaseRegister, handleSubmit: purchaseHandleSubmit, reset: purchaseReset, control: purchaseControl, formState: { errors: purchaseErrors } } = useForm({
        defaultValues: { number: 1, product: {} }
    });


    // Prepare list of classes and packages for new purchases
    var classesForPurchase = [];
    classesForPurchase = Cdata?.map(edge => ({
        value: edge.node.id,
        label: edge.node.name,
        group: "class"
    }));
    var packagesForPurchase = [];
    packagesForPurchase = Pdata?.map(edge => ({
        value: edge.node.id,
        label: edge.node.name,
        group: "package"
    }));

    const products = packagesForPurchase?.concat(classesForPurchase);

    function convertGraphQLData(data: types.Fs_PurchasesConnection): RegistrationsListType {
        const convertedData = {
            regs: [],
            allSignups: []
        };

        data.edges.forEach(purchase => {
            const purchaseNode = purchase.node;
            const purchaseObject = {
                id: purchaseNode.id,
                date: purchaseNode.Date,
                studentId: purchaseNode.fs_students.id,
                class: purchaseNode.fs_classes?.name,
                package: purchaseNode.fs_packages?.name,
                name: purchaseNode.fs_classes?.name || purchaseNode.fs_packages?.name,
                registrations: []
            };

            purchaseNode.fs_registrationsCollection.edges.forEach(registration => {
                const registrationNode = registration.node;
                const registrationObject = {
                    id: registrationNode.id,
                    class: registrationNode.fs_classes?.name,
                    classId: registrationNode.fs_classes?.id,
                    availableNum: registrationNode.AvailableNum,
                    purchase: purchaseObject,
                    date: (SchoolTime.fromISO(purchaseObject.date))?.toDateTime().toFormat("D"),
                    prodName: purchaseObject.name,
                    signups: [],
                    signedNum: 0
                };
                convertedData.regs.push(registrationObject);

                var signup_num = 0;
                registrationNode.fs_signupCollection.edges.forEach(signup => {
                    const date = SchoolTime.fromISO(signup.node?.fs_events?.date);
                    const signupObject = {
                        status: signup.node.status,
                        eventDate: date,
                        id: signup.node.id,
                        class: registrationObject.class
                    };
                    if (signup.node.status == 0) signup_num++;

                    registrationObject.signups.push(signupObject);
                    convertedData.allSignups.push(signupObject);
                });

                registrationObject.signedNum = signup_num;
                purchaseObject.registrations.push(registrationObject);
            });
        });
        // Return list of all signups sorted in order of event date, soonest first
        convertedData.allSignups.sort(
            (a, b) => { 
                return b?.eventDate?.toDateTime() - a?.eventDate?.toDateTime(); 
            }
        );
        return convertedData;
    }

    useEffect(() => {
        if (data) {
            const conv = convertGraphQLData(data.fs_purchasesCollection);
            setPurchasesList(conv);
            setSignupList(conv.allSignups);
        }
    }, [data]);


    // ================================= Signups table definition ===================================

    const [deleteSignUpMutation, { loading: deleteSignUpLoading, error: deleteSignUpError }] = useMutation(deleteSignUpQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });

    const handleSignUpDeleteClick = (id) => {
        deleteSignUpMutation({ variables: { id: id } });
    };


    const [addPurchaseMutation, { loading: addPurchaseLoading, error: addPurchaseError }] = useMutation(addPurchaseQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });



    const handleAddSignUpClick = (registration: any) => {
        setRegistrationRow(registration);
        setIsAddSignUpModalOpen(true);
    };


    if (loading || !purchasesList) return (<div>Loading</div>)
    if (error) return (<div>Error</div>)

    // Add new purchase and registration                 
    const onPurchaseFormSubmit = (data) => {

        if (data.product.group == "package") {
            addPurchaseMutation({ variables: { st: props.StudentID, so: 2 /*admin*/, pa: data.product.value, cl: 0, ad: 0, nm: data.number } });
        }
        else {
            addPurchaseMutation({ variables: { st: props.StudentID, so: 2 /*admin*/, pa: 0, cl: data.product.value, ad: 0, nm: data.number } });
        }

        setIsPurchaseModalOpen(false);
    };

    function comp_func(option, value) {
        return option.id == value.id;
    }

    return (
        <Card sx={{ padding: "4px 16px 8px" }}>
            <MDBoxRoot ownerState={{
                variant: "contained",
                bgColor: "secondary",
                coloredShadow: "secondary",
            }}
                borderRadius={2}
                sx={{ display: 'flex', width: '100%' }} pb={1} px={2} mt={-1} >
                <MDTypographyRoot variant="h3" ownerState={{ color: "white" }}>
                    Complete Schedule
                </MDTypographyRoot>
            </MDBoxRoot>
            <MDBoxRoot component="table" sx={{ borderSpacing: "0px" }} mt={3}>
                <MDBoxRoot component="thead" ownerState={{
                    variant: "contained",
                    bgColor: "light"
                }}
                    borderRadius={2}>
                    <MDBoxRoot component="tr" >
                        <MDBoxRoot component="td" textAlign="left" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Date
                            </MDTypographyRoot>
                        </MDBoxRoot>
                        <MDBoxRoot component="td" textAlign="left" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Class Name
                            </MDTypographyRoot>
                        </MDBoxRoot>
                        <MDBoxRoot component="td" textAlign="center" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Status
                            </MDTypographyRoot>
                        </MDBoxRoot>
                        <MDBoxRoot component="td" textAlign="center" px={1}>
                            <MDTypographyRoot variant="h5"
                                ownerState={{
                                    color: "dark",
                                    fontWeight: "bold"
                                }} >
                                Delete
                            </MDTypographyRoot>
                        </MDBoxRoot>
                    </MDBoxRoot>
                </MDBoxRoot>

                <MDBoxRoot component="tbody">
                    {signupList.map((signup) => (
                        <MDBoxRoot component="tr" key={signup.id}>
                            <MDBoxRoot component="th" ownerState={{ scope: "row" }} textAlign="left">
                                <MDTypographyRoot variant="h5"
                                    ownerState={{
                                        color: "inherit",
                                        fontWeight: "medium"
                                    }}>
                                    {signup.eventDate?.toDateTime().toFormat("f")}
                                </MDTypographyRoot>
                            </MDBoxRoot>
                            <MDBoxRoot component="td" textAlign="left">
                                <MDTypographyRoot variant="h5"
                                    ownerState={{
                                        color: "inherit",
                                        fontWeight: "regular"
                                    }}>
                                    {signup.class}
                                </MDTypographyRoot>
                            </MDBoxRoot>
                            <MDBoxRoot component="td" textAlign="center">
                                <MDTypographyRoot variant="h5"
                                    ownerState={{
                                        color: "inherit",
                                        fontWeight: "regular"
                                    }}>
                                    {getStatus(signup.status)}
                                </MDTypographyRoot>
                            </MDBoxRoot>
                            <MDBoxRoot component="td" textAlign="center">
                                <IconButton aria-label="Delete" onClick={() => { handleSignUpDeleteClick(signup.id); }}>
                                    <DeleteIcon />
                                </IconButton>
                            </MDBoxRoot>
                        </MDBoxRoot>
                    ))}

                </MDBoxRoot>
            </MDBoxRoot>





        </Card>
    )
}

export default StudentComplete;

function PurchaseRow(props: { row: Registration, handleRegistrationDeleteClick, handleAddSignUpClick, handleSignUpDeleteClick }) {
    const { row, handleRegistrationDeleteClick, handleAddSignUpClick, handleSignUpDeleteClick } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <React.Fragment>
            <MDBoxRoot component="tr" sx={{ '& > *': { borderBottom: 'solid 1px rgba(0, 0, 0, 0.08);' }, '& > *:hover': { backgroundColor: "black" } }}>
                <MDBoxRoot component="td">
                    {row.signedNum > 0 &&
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>}
                </MDBoxRoot>

                <MDBoxRoot component="th" sx={{ '& > *:hover': { backgroundColor: "black" } }}>
                    <MDTypographyRoot variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.prodName}
                    </MDTypographyRoot></MDBoxRoot>
                <MDBoxRoot component="td" textAlign="center" px={2}>
                    <MDTypographyRoot variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.date}
                    </MDTypographyRoot></MDBoxRoot>
                <MDBoxRoot component="td" textAlign="left">
                    <MDTypographyRoot variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.class}
                    </MDTypographyRoot></MDBoxRoot>
                <MDBoxRoot component="td" textAlign="center">
                    <MDTypographyRoot variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.availableNum}
                    </MDTypographyRoot></MDBoxRoot>
                <MDBoxRoot component="td" textAlign="center">
                    <MDTypographyRoot variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.signedNum}
                    </MDTypographyRoot></MDBoxRoot>
                <MDBoxRoot component="td">
                    {(row.availableNum > 0) &&
                        <IconButton aria-label="Sign Up" onClick={() => { handleAddSignUpClick(row); }}>
                            <EventAvailableIcon />
                        </IconButton>}
                </MDBoxRoot>
                <MDBoxRoot component="td">
                    <IconButton aria-label="Delete" onClick={() => { handleRegistrationDeleteClick(row); }}>
                        <DeleteIcon />
                    </IconButton>
                </MDBoxRoot>
            </MDBoxRoot>
            <MDBoxRoot component="tr" ownerState={{
                variant: "contained",
                bgColor: "light"
            }}>
                <td colSpan={5} style={{ paddingBottom: 0, paddingTop: 0, textAlign: "center" }}>
                    <Collapse in={open} timeout="auto" unmountOnExit >
                        <MDBoxRoot sx={{ margin: 0 }} width="100%">
                            <MDTypographyRoot variant="h6" gutterBottom>
                                Scheduled Events
                            </MDTypographyRoot>
                            <MDBoxRoot component="table"
                                sx={{ borderSpacing: "0px", border: "solid 1px", width: "100%" }}>
                                <MDBoxRoot component="thead"
                                    borderRadius={2}>
                                    <MDBoxRoot component="tr">
                                        <MDBoxRoot component="td">
                                            <MDTypographyRoot variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Date
                                            </MDTypographyRoot>
                                        </MDBoxRoot>
                                        <MDBoxRoot component="td">
                                            <MDTypographyRoot variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Class Name
                                            </MDTypographyRoot>
                                        </MDBoxRoot>
                                        <MDBoxRoot component="td">
                                            <MDTypographyRoot variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Status
                                            </MDTypographyRoot>
                                        </MDBoxRoot>
                                        <MDBoxRoot component="td">
                                            <MDTypographyRoot variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Delete
                                            </MDTypographyRoot>
                                        </MDBoxRoot>
                                    </MDBoxRoot>
                                </MDBoxRoot>
                                <MDBoxRoot component="tbody">
                                    {row.signups.map((signup) => (
                                        <MDBoxRoot key={signup.id} component="tr">
                                            <MDBoxRoot component="td" textAlign="center">
                                                <MDTypographyRoot variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "medium"
                                                    }}>
                                                    {signup.eventDate}
                                                </MDTypographyRoot>
                                            </MDBoxRoot>
                                            <MDBoxRoot component="td" textAlign="center">
                                                <MDTypographyRoot variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    {signup.class}
                                                </MDTypographyRoot>
                                            </MDBoxRoot>
                                            <MDBoxRoot component="td" textAlign="center">
                                                <MDTypographyRoot variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    {getStatus(signup.status)}
                                                </MDTypographyRoot></MDBoxRoot>
                                            <MDBoxRoot component="td" textAlign="center">
                                                <MDTypographyRoot variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    <IconButton aria-label="Delete" onClick={() => { handleSignUpDeleteClick(signup.id); }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </MDTypographyRoot></MDBoxRoot>
                                        </MDBoxRoot>
                                    ))}
                                </MDBoxRoot>
                            </MDBoxRoot>
                        </MDBoxRoot>
                    </Collapse>
                </td>
            </MDBoxRoot>
        </React.Fragment>
    );
}



